import { mergeProps as _mergeProps, createTextVNode as _createTextVNode, createVNode as _createVNode } from "vue";
export default {
  name: 'CurrentLocationIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return _createVNode("svg", _mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-current-location",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [_createTextVNode("   "), _createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M12 12m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M12 12m-8 0a8 8 0 1 0 16 0a8 8 0 1 0 -16 0"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M12 2l0 2"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M12 20l0 2"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M20 12l2 0"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M2 12l2 0"
    }, null), _createTextVNode(" ")]);
  }
};